export default "__VITE_ASSET__CAEN4oy3__"